import { saveParse } from './bigNumber'

export const concatAmountCurrency = (amount: number, currency: string) => `${amount} ${currency || ''}`

export const formatAmountCurrency = (amount: number, currency: string, decimals = 2) => {
  const formatted = saveParse(amount).toFormat(decimals)
  return concatAmountCurrency(formatted, currency)
}
